// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__T45F2","arrowWrapper":"styles_arrowWrapper__LPRcT","left":"styles_left__sOogp"};